import { combineReducers } from "@reduxjs/toolkit";
import usersReducer from "./Slice";
import LoaderReducer from "./Loader";
import LoaderReducer2 from "./Loader2";
import employeeInformationReducer from "./employeeInformationSlice";

const rootReducer = combineReducers({
  Loader: LoaderReducer,
  Loader2: LoaderReducer2,
  employeeInformation: employeeInformationReducer.employeeInformation,
  employeeBulkUploadGetData: usersReducer.employeeBulkUploadGetData,
  employeeBulkUpload: usersReducer.employeeBulkUpload,

  ErrorDisplay: usersReducer.ErrorDisplay,
  users: usersReducer.userReducer,
  Table: usersReducer.TableDataReducer,
  SideBarFiles: usersReducer.SideBarFiles,
  sidebardispatchCall: usersReducer.sidebardispatchCall,
  ForgotP: usersReducer.ForgotPassword,
  OptCall: usersReducer.OtpVerifyCall,
  UpdatePas: usersReducer.ForgotPassword,
  roleCreate: usersReducer.roleCreate,
  rolelists: usersReducer.RoleLists,
  SideBarActive: usersReducer.SideBarActive,
  roleDelete: usersReducer.roleDelete,
  roleRetrieve: usersReducer.roleretrieve,
  ResendOtp: usersReducer.ResendOtp,
  sheetBulkUpload: usersReducer.sheetBulkUpload,
  sheetBulkUploadGetData: usersReducer.sheetBulkUploadGetData,
  RoleEdits: usersReducer.RoleEditPart,
  Usergetlists: usersReducer.UsergetList,
  UserDelete: usersReducer.UserDelete,
  UserCreate: usersReducer.UserCreate,
  EmployeeExitRequest: usersReducer.EmployeeExitRequest,
  UserEdit: usersReducer.UserEdit,
  UserRetrieve: usersReducer.UserRetrieve,
  Language: usersReducer.Language,
  GeoState: usersReducer.GeoState,
  stateCreates: usersReducer.stateCreates,
  StateDelete: usersReducer.StateDelete,
  CasualLabourDelete: usersReducer.CasualLabourDelete,
  StateRetrieve: usersReducer.StateRetrieve,
  StateEdit: usersReducer.StateEdit,
  regioncall: usersReducer.regioncall,
  RegionDelete: usersReducer.RegionDelete,
  RegionRetrieve: usersReducer.RegionRetrieve,
  RegionEditCalls: usersReducer.RegionEditCalls,
  ZonePart: usersReducer.ZonePart,
  ZoneEditCalls: usersReducer.ZoneEditCalls,
  ZoneRetrieve: usersReducer.ZoneRetrieve,
  ZoneDelete: usersReducer.ZoneDelete,
  ZoneCreate: usersReducer.ZoneCreate,
  ClientList: usersReducer.ClientList,
  ClientCreate: usersReducer.ClientCreate,
  ClientDeletes: usersReducer.ClientDeletes,
  ClientRetrieves: usersReducer.ClientRetrieves,
  ClientEditCalls: usersReducer.ClientEditCalls,
  ClientBranch: usersReducer.ClientBranch,
  ClientBranchCreate: usersReducer.ClientBranchCreate,
  ClientBranchDeleteCall: usersReducer.ClientBranchDeleteCall,
  BranchEdits: usersReducer.BranchEdits,
  BranchRetrieve: usersReducer.BranchRetrieve,
  BranchSearchpart: usersReducer.BranchSearchpart,
  ShiftList: usersReducer.ShiftList,
  ShiftDelete: usersReducer.ShiftDelete,
  ShiftSearch: usersReducer.ShiftSearch,
  shiftCreate: usersReducer.shiftCreate,
  ShiftEdits: usersReducer.ShiftEdits,
  ShiftRetrieveData: usersReducer.ShiftRetrieveData,
  EmployeeListsdata: usersReducer.EmployeeListsdata,
  EmployeeCreate: usersReducer.EmployeeCreate,
  EmployeeDelete: usersReducer.EmployeeDelete,
  EmployeeEdits: usersReducer.EmployeeEdits,
  EmployeeRetrieve: usersReducer.EmployeeRetrieve,
  ClientBranchIDs: usersReducer.ClientBranchIDs,
  EmployeeDATASList: usersReducer.EmployeeDATASList,
  EmployeeListPresons: usersReducer.EmployeeListPresons,
  EmployeeVerificationsNeed: usersReducer.EmployeeVerificationsNeed,
  EmployeeProfile: usersReducer.EmployeeProfile,
  FormsIDList: usersReducer.FormsIDList,
  CasualFormsIDList: usersReducer.CasualFormsIDList,
  FormsSDETAILS: usersReducer.FormsSDETAILS,
  AddressForms: usersReducer.AddressForms,
  IdverificationName: usersReducer.IdverificationName,
  BankDetails: usersReducer.BankDetails,
  EducationAction: usersReducer.EducationAction,
  PreviousEmp: usersReducer.PreviousEmp,
  FamilyList: usersReducer.FamilyList,
  DeclarationCall: usersReducer.DeclarationCall,
  ESIdetails: usersReducer.ESIdetails,
  JOBOfferCall: usersReducer.JOBOfferCall,
  ApprovalCall: usersReducer.ApprovalCall,
  VerifiedUsers: usersReducer.VerifiedUsers,
  JoningDateCall: usersReducer.JoningDateCall,
  SignatureCall: usersReducer.SignatureCall,
  UserFilterCall: usersReducer.UserFilterCall,
  EmployeeListfilterPresons: usersReducer.EmployeeListfilterPresons,
  excelsheets: usersReducer.excelsheets,
  makingChanges: usersReducer.makingChanges,
  LeaveTypeCareteCall: usersReducer.LeaveTypeCareteCall,
  LeaveTypeList: usersReducer.LeaveTypeList,
  LeaveTypeDelete: usersReducer.LeaveTypeDelete,
  LeaveTypeRetrieveCall: usersReducer.LeaveTypeRetrieveCall,
  LeaveTypeEditCall: usersReducer.LeaveTypeEditCall,
  LeavePremissionLists: usersReducer.LeavePremissionLists,
  LeavePremissionSearchLists: usersReducer.LeavePremissionSearchLists,
  LeavepermissionDeleteCall: usersReducer.LeavepermissionDeleteCall,
  LeavePermissionEditsCall: usersReducer.LeavePermissionEditsCall,
  LeavePermissionRetrieveCall: usersReducer.LeavePermissionRetrieveCall,
  DashboardCall: usersReducer.DashboardCall,
  NumberCounts: usersReducer.NumberCounts,
  signaturepad: usersReducer.signaturepad,
  LeaveStatusListed: usersReducer.LeaveStatusListed,
  ShfitData: usersReducer.ShfitData,
  shiftPermission: usersReducer.shiftPermission,
  ShiftPermissionEditsCall: usersReducer.ShiftPermissionEditsCall,
  ShiftPermissionRetrieveCall: usersReducer.ShiftPermissionRetrieveCall,
  ShiftpermissionDeleteCall: usersReducer.ShiftpermissionDeleteCall,
  reinvestmentCall: usersReducer.reinvestmentCall,
  reInvestmentRetrieveCall: usersReducer.reInvestmentRetrieveCall,
  ReinvestmentEditCall: usersReducer.ReinvestmentEditCall,
  ShifteexcelshettRetriev: usersReducer.ShifteexcelshettRetriev,
  OndutyCalls: usersReducer.OndutyCalls,
  onDutyRetrieveCall: usersReducer.onDutyRetrieveCall,
  OnDutyEditsCall: usersReducer.OnDutyEditsCall,
  OnDutyDeleteCall: usersReducer.OnDutyDeleteCall,
  resignCall: usersReducer.resignCall,
  ResignRetrieveCall: usersReducer.ResignRetrieveCall,
  ResignEditsCall: usersReducer.ResignEditsCall,
  ResignDeleteCall: usersReducer.ResignDeleteCall,
  ExitCall: usersReducer.ExitCall,
  ExitRetrieveCall: usersReducer.ExitRetrieveCall,
  ExitEditsCall: usersReducer.ExitEditsCall,
  ExitDeleteCall: usersReducer.ExitDeleteCall,
  ExitNodueEditCall: usersReducer.ExitNodueEditCall,
  AppraisliceCall: usersReducer.AppraisliceCall,
  AppraisalRetrieveCall: usersReducer.AppraisalRetrieveCall,
  AppraisalEditCall: usersReducer.AppraisalEditCall,
  payslip: usersReducer.payslip,
  payslipCreate: usersReducer.payslipCreate,
  payslipEdit: usersReducer.payslipEdit,
  payslipRetrieve: usersReducer.payslipRetrieve,
  BasicFormCreated: usersReducer.BasicFormCreated,
  AddressCraeteForms: usersReducer.AddressCraeteForms,
  JOBOfferCreateCall: usersReducer.JOBOfferCreateCall,
  EducationcreateAction: usersReducer.EducationcreateAction,
  fieldagentBracnhdata: usersReducer.fieldagentBracnhdata,
  EmployeeListManagerPresons: usersReducer.EmployeeListManagerPresons,
  BasicFormEdit: usersReducer.BasicFormEdit,
  AddressEditorms: usersReducer.AddressEditorms,
  JOBOfferEditall: usersReducer.JOBOfferEditall,
  IdverificationNameCreate: usersReducer.IdverificationNameCreate,
  BankEditDetails: usersReducer.BankEditDetails,
  ESIEditdetails: usersReducer.ESIEditdetails,
  ESICreatedetails: usersReducer.ESICreatedetails,
  AddressForms: usersReducer.AddressForms,
  IdverificationName: usersReducer.IdverificationName,
  BankDetails: usersReducer.BankDetails,
  EducationAction: usersReducer.EducationAction,
  PreviousEmp: usersReducer.PreviousEmp,
  FamilyList: usersReducer.FamilyList,
  DeclarationCall: usersReducer.DeclarationCall,
  ESIdetails: usersReducer.ESIdetails,
  JOBOfferCall: usersReducer.JOBOfferCall,
  ApprovalCall: usersReducer.ApprovalCall,
  VerifiedUsers: usersReducer.VerifiedUsers,
  JoningDateCall: usersReducer.JoningDateCall,
  SignatureCall: usersReducer.SignatureCall,
  UserFilterCall: usersReducer.UserFilterCall,
  EmployeeListfilterPresons: usersReducer.EmployeeListfilterPresons,
  excelsheets: usersReducer.excelsheets,
  makingChanges: usersReducer.makingChanges,
  LeaveTypeCareteCall: usersReducer.LeaveTypeCareteCall,
  LeaveTypeList: usersReducer.LeaveTypeList,
  LeaveTypeDelete: usersReducer.LeaveTypeDelete,
  LeaveTypeRetrieveCall: usersReducer.LeaveTypeRetrieveCall,
  LeaveTypeEditCall: usersReducer.LeaveTypeEditCall,
  LeavePremissionLists: usersReducer.LeavePremissionLists,
  LeavePremissionSearchLists: usersReducer.LeavePremissionSearchLists,
  LeavepermissionDeleteCall: usersReducer.LeavepermissionDeleteCall,
  LeavePermissionEditsCall: usersReducer.LeavePermissionEditsCall,
  LeavePermissionRetrieveCall: usersReducer.LeavePermissionRetrieveCall,
  DashboardCall: usersReducer.DashboardCall,
  NumberCounts: usersReducer.NumberCounts,
  signaturepad: usersReducer.signaturepad,
  LeaveStatusListed: usersReducer.LeaveStatusListed,
  ShfitData: usersReducer.ShfitData,
  shiftPermission: usersReducer.shiftPermission,
  ShiftPermissionEditsCall: usersReducer.ShiftPermissionEditsCall,
  ShiftPermissionRetrieveCall: usersReducer.ShiftPermissionRetrieveCall,
  ShiftpermissionDeleteCall: usersReducer.ShiftpermissionDeleteCall,
  reinvestmentCall: usersReducer.reinvestmentCall,
  reInvestmentRetrieveCall: usersReducer.reInvestmentRetrieveCall,
  ReinvestmentEditCall: usersReducer.ReinvestmentEditCall,
  ShifteexcelshettRetriev: usersReducer.ShifteexcelshettRetriev,
  OndutyCalls: usersReducer.OndutyCalls,
  onDutyRetrieveCall: usersReducer.onDutyRetrieveCall,
  OnDutyEditsCall: usersReducer.OnDutyEditsCall,
  OnDutyDeleteCall: usersReducer.OnDutyDeleteCall,
  resignCall: usersReducer.resignCall,
  ResignRetrieveCall: usersReducer.ResignRetrieveCall,
  ResignEditsCall: usersReducer.ResignEditsCall,
  ResignDeleteCall: usersReducer.ResignDeleteCall,
  ExitCall: usersReducer.ExitCall,
  ExitRetrieveCall: usersReducer.ExitRetrieveCall,
  ExitEditsCall: usersReducer.ExitEditsCall,
  ExitDeleteCall: usersReducer.ExitDeleteCall,
  AppraisliceCall: usersReducer.AppraisliceCall,
  AppraisalRetrieveCall: usersReducer.AppraisalRetrieveCall,
  AppraisalEditCall: usersReducer.AppraisalEditCall,
  payslip: usersReducer.payslip,
  payslipCreate: usersReducer.payslipCreate,
  payslipEdit: usersReducer.payslipEdit,
  payslipRetrieve: usersReducer.payslipRetrieve,
  BasicFormCreated: usersReducer.BasicFormCreated,
  AddressCraeteForms: usersReducer.AddressCraeteForms,
  JOBOfferCreateCall: usersReducer.JOBOfferCreateCall,
  EducationcreateAction: usersReducer.EducationcreateAction,
  fieldagentBracnhdata: usersReducer.fieldagentBracnhdata,
  EmployeeListManagerPresons: usersReducer.EmployeeListManagerPresons,
  BasicFormEdit: usersReducer.BasicFormEdit,
  AddressEditorms: usersReducer.AddressEditorms,
  JOBOfferEditall: usersReducer.JOBOfferEditall,
  IdverificationNameCreate: usersReducer.IdverificationNameCreate,
  BankEditDetails: usersReducer.BankEditDetails,
  ESIEditdetails: usersReducer.ESIEditdetails,
  ESICreatedetails: usersReducer.ESICreatedetails,
  PreviousApiCallLine: usersReducer.PreviousApiCallLine,
  DatafetchCall: usersReducer.DatafetchCall,
  IdverificationNameEdit: usersReducer.IdverificationNameEdit,
  PreviousEditEmp: usersReducer.PreviousEditEmp,
  PreviousCreateEmp: usersReducer.PreviousCreateEmp,
  DeclarationEditCall: usersReducer.DeclarationEditCall,
  DeclarationcreateCall: usersReducer.DeclarationcreateCall,
  grievanceTypeCall: usersReducer.grievanceTypeCall,
  GrievanceCall: usersReducer.GrievanceCall,
  GrievanceretrieveCall: usersReducer.GrievanceretrieveCall,
  GrievanceEditCall: usersReducer.GrievanceEditCall,
  FamilycreateList: usersReducer.FamilycreateList,
  FamilyEditList: usersReducer.FamilyEditList,
  performanceTypeCall: usersReducer.performanceTypeCall,
  performanceRetrieveTypeCall: usersReducer.performanceRetrieveTypeCall,
  performanceDeleteTypeCall: usersReducer.performanceDeleteTypeCall,
  performanceUpdateTypeCall: usersReducer.performanceUpdateTypeCall,
  performanceCreateTypeCall: usersReducer.performanceCreateTypeCall,
  performanceChildTypeCall: usersReducer.performanceChildTypeCall,
  performanceChildRetrieveTypeCall:
    usersReducer.performanceChildRetrieveTypeCall,
  performanceChildCreateTypeCall: usersReducer.performanceChildCreateTypeCall,
  performanceUpdateChildTypeCall: usersReducer.performanceUpdateChildTypeCall,
  performanceChildDeleteTypeCall: usersReducer.performanceChildDeleteTypeCall,
  EducationPutAction: usersReducer.EducationPutCall,
  PerformFieldAGentGet: usersReducer.PerformFieldAGentGet,
  PerformsFieldAgentRetrieve: usersReducer.PerformsFieldAgentRetrieve,
  PerformsFieldAgentCreate: usersReducer.PerformsFieldAgentCreate,
  PerformsFieldAgentEdit: usersReducer.PerformsFieldAgentEdit,
  clientDetailsCall: usersReducer.clientDetailsCall,
  ExcelSheetUploadFieldST: usersReducer.ExcelSheetUploadFieldST,
  createEmployeeCallSign: usersReducer.createEmployeeCallSign,
  GrivanceDatas: usersReducer.GrivanceDatas,
  GrievanceApproveretriveCall: usersReducer.GrievanceApproveretriveCall,
  grievanceEMpListCall: usersReducer.grievanceEMpListCall,
  AttendanceApproveeCall: usersReducer.AttendanceApproveeCall,
  AttendanceRetriveCall: usersReducer.AttendanceRetriveCall,
  AttendanceCall: usersReducer.AttendanceCall,
  ManPowerActiveDataTabs: usersReducer.ManPowerActiveDataTabs,
  PerformsFieldAgentseparateRetrievename:
    usersReducer.PerformsFieldAgentseparateRetrievename,
  AttendanceexportCall: usersReducer.AttendanceexportCall,
  BlacklistLists: usersReducer.BlacklistLists,
  BlacklistEditCall: usersReducer.BlacklistEditCall,
  BlacklistRetrieveCall: usersReducer.BlacklistRetrieveCall,
  SiteTransfertLists: usersReducer.SiteTransfertLists,
  SiteTramsferEditCall: usersReducer.SiteTramsferEditCall,
  SiteTransferRetrieveCall: usersReducer.SiteTransferRetrieveCall,
  SiteTrabsferCreateCall: usersReducer.SiteTrabsferCreateCall,
  BlacklistCreateCall: usersReducer.BlacklistCreateCall,
  SendNotificationferCreateCall: usersReducer.SendNotificationferCreateCall,
  pdfdownloadcall: usersReducer.pdfdownloadcall,
  GrievanceDeleteDataCall: usersReducer.GrievanceDeleteDataCall,
  AppraisalPostcall: usersReducer.AppraisalPostcall,
  AttendanceExportDatacall: usersReducer.AttendanceExportDatacall,
  AdminuseraccesslistCall: usersReducer.AdminuseraccesslistCall,
  adminuseraccesEDIT: usersReducer.adminuseraccesEDIT,
  adminuseraccessRETRIEVE: usersReducer.adminuseraccessRETRIEVE,
  adminuseraccesscrate: usersReducer.adminuseraccesscrate,
  adminuseraccesDelETE: usersReducer.adminuseraccesDelETE,
  idverfiyicationapidatas: usersReducer.idverfiyicationapidatas,
  exportexcelsheetforEMPandClien: usersReducer.exportexcelsheetforEMPandClien,
  payslipDelete: usersReducer.payslipDelete,
  UpdateDatafromChequeOrPassbook: usersReducer.UpdateDatafromChequeOrPassbook,
  AttendancezRequestSliceList: usersReducer.AttendancezRequestSliceList,
  OtherPartyApiForPAn: usersReducer.OtherPartyApiForPAn,
  ActveEmployeeList: usersReducer.ActveEmployeeList,
  ApproveEmployeeTOleft: usersReducer.ApproveEmployeeTOleft,
  RetrieveForAproEmployeeTOleft: usersReducer.RetrieveForAproEmployeeTOleft,
  ActiveEmployeeCreateData: usersReducer.ActiveEmployeeCreateData,
  PerformanceAnswerExports: usersReducer.PerformanceAnswerExports,
  AppraisalDatasListesUDS: usersReducer.AppraisalDatasListesUDS,
  AppraisalSliceDatasss: usersReducer.AppraisalSliceDatasss,
  PutCreateSuperviorserList: usersReducer.PutCreateSuperviorserList,
  SuperviorsSlice: usersReducer.SuperviorsSlice,
  attendacemulitipleLists: usersReducer.attendacemulitipleLists,
  PerfromancesheaderListedsicess: usersReducer.PerfromancesheaderListedsicess,
  NeededdatasListed: usersReducer.NeededdatasListed,
  EmployeeDashBoardAttedances: usersReducer.EmployeeDashBoardAttedances,
  DashboardwithempAttendanceCall: usersReducer.DashboardwithempAttendanceCall,
  UserDetailsExportSheet: usersReducer.UserDetailsExportSheet,
  QueryQuetionsDatas: usersReducer.QueryQuetionsDatas,
  QueryQuestionsCreate: usersReducer.QueryQuestionsCreate,
  QueryQuestionsRetrieve: usersReducer.QueryQuestionsRetrieve,
  QueryQuestionsEdit: usersReducer.QueryQuestionsEdit,
  QuerySubQuetionsDatas: usersReducer.QuerySubQuetionsDatas,
  QuerySubQuestionsCreate: usersReducer.QuerySubQuestionsCreate,
  QuerySubQuestionsEditions: usersReducer.QuerySubQuestionsEditions,
  QuerySubQuestionsRetrieve: usersReducer.QuerySubQuestionsRetrieve,
  QueryQuestionsDelete: usersReducer.QueryQuestionsDelete,
  QuerySUBQuestionsDelete: usersReducer.QuerySUBQuestionsDelete,
  TrackingrecordgetList: usersReducer.TrackingrecordgetList,
  QueryTrackingrecordgetListEditions:
    usersReducer.QueryTrackingrecordgetListEditions,
  QueryTrackingrecordgetListRetrieve:
    usersReducer.QueryTrackingrecordgetListRetrieve,
  TrackingDelete: usersReducer.TrackingDelete,
  TrackingCreateSliceName: usersReducer.TrackingCreateSliceName,
  FinanceGetListedData: usersReducer.FinanceGetListedData,
  FinanceGetListedExportData: usersReducer.FinanceGetListedExportData,
  AttendanceREPORTDataCall: usersReducer.AttendanceREPORTDataCall,
  OnboaderDetailsListOut: usersReducer.OnboaderDetailsListOut,
  AadharOtherPartyAPIPhoneOtp: usersReducer.AadharOtherPartyAPIPhoneOtp,
  aadharsentSubmitthephoneotp: usersReducer.aadharsentSubmitthephoneotp,
  PANCARDthephoneotp: usersReducer.PANCARDthephoneotp,
  PANCARDtheSUBMITEDphoneotp: usersReducer.PANCARDtheSUBMITEDphoneotp,
  SuperviorsEmployeee: usersReducer.SuperviorsEmployeee,
  UserSelectedPayloadsSlice: usersReducer.UserSelectedPayloadsSlice,
  pennydropforBankVerify: usersReducer.pennydropforBankVerify,
  pennydropforBank: usersReducer.pennydropforBank,
  UserSelectedDashboArdEmployeesgetdatas:
    usersReducer.UserSelectedDashboArdEmployeesgetdatas,
  ReportSheetpostmethoh: usersReducer.ReportSheetpostmethoh,
  ReportSheetData: usersReducer.ReportSheetData,
  ///---qpms--employees----
  CustomUDSEMployeeLogin: usersReducer.CustomUDSEMployeeLogin,
  CustomUDSEMployeeSendOTP: usersReducer.CustomUDSEMployeeSendOTP,
  UDSemployeeRoleActions: usersReducer.UDSemployeeRoleActions,
  FetchReimbursementCall: usersReducer.FetchReimbursementCall,
  laguagefoetheemployees: usersReducer.laguagefoetheemployees,
  OndutyDaysemp: usersReducer.OndutyDaysemp,
  OndutyDaysempCreate: usersReducer.OndutyDaysempCreate,
  CreatePermissionEmp: usersReducer.CreatePermissionEmp,
  CreateRegularizationEmp: usersReducer.CreateRegularizationEmp,
  AttenDance_RegularizationCallEmp:
    usersReducer.AttenDance_RegularizationCallEmp,
  AttenDancePermissionCallEmp: usersReducer.AttenDancePermissionCallEmp,

  ShiftDatas: usersReducer.ShiftDatas,
  AttenDanceCall: usersReducer.AttenDanceCall,
  // NumberCounts: usersReducer.NumberCounts,
  LeaveTypeData: usersReducer.LeaveTypeData,
  AttenDancePermissionCall: usersReducer.AttenDancePermissionCall,
  CreateLeaveCall: usersReducer.CreateLeaveCall,
  CreatePermissionCall: usersReducer.CreatePermissionCall,
  // onDutyCall: usersReducer.onDutyCall,
  CalendarCall: usersReducer.CalendarCall,
  CheckInOutCall: usersReducer.CheckInOutCall,
  PayslipCall: usersReducer.PayslipCall,
  FetchReimbursementCall: usersReducer.FetchReimbursementCall,
  CheckInOutPutMethodCall: usersReducer.CheckInOutPutMethodCall,
  OnboardngCounts: usersReducer.OnboardngCounts,
  ProfileSignatureEditCalls: usersReducer.ProfileSignatureEditCalls,
  ProfileSignatureCalls: usersReducer.ProfileSignatureCalls,
  OverAllReportCall: usersReducer.OverAllReportCall,
  OverAllReportCreateCall: usersReducer.OverAllReportCreateCall,
  OverAllReportEditCall: usersReducer.OverAllReportEditCall,
  OverAllReportRetrieveCall: usersReducer.OverAllReportRetrieveCall,
  OverAllReportEmployeeListCall: usersReducer.OverAllReportEmployeeListCall,
  OverAllReportEmployeeListExportCall:
    usersReducer.OverAllReportEmployeeListExportCall,
  sendEmailREportEditData: usersReducer.sendEmailREportEditData,
  sendEmailREportgetData: usersReducer.sendEmailREportgetData,
  DashboardOnboardOverviewCall: usersReducer.DashboardOnboardOverviewCall,
  OverallStateCallData: usersReducer.OverallStateCallData,
  ResentOtpVeririedPhoneNumbers: usersReducer.ResentOtpVeririedPhoneNumbers,
  StateManagementOverallCall: usersReducer.StateManagementOverallCall,
  AttendanceLocationSliceCall: usersReducer.AttendanceLocationSliceCall,
  AttendanceLocationSliceCreateCall:
    usersReducer.AttendanceLocationSliceCreateCall,
  AttendanceLocationSliceEditionCall:
    usersReducer.AttendanceLocationSliceEditionCall,
  AttendanceLocationSliceDeletionCall:
    usersReducer.AttendanceLocationSliceDeletionCall,
  AttendanceLocationSliceRetrieveMethosCall:
    usersReducer.AttendanceLocationSliceRetrieveMethosCall,
  SupportDocumentEdit: usersReducer.SupportDocumentEdit,
  SupportDocumentFetch: usersReducer.SupportDocumentFetch,
  myonboardingDatas: usersReducer.myonboardingDatas,
  ApproverequestDatass: usersReducer.ApproverequestDatass,
  CasualApproveRequestDatas: usersReducer.CasualApproveRequestDatas,
  RegeneratePDFCalls: usersReducer.RegeneratePDFCalls,
  CasualOnboardingPdfPreviewCall: usersReducer.CasualOnboardingPdfPreviewCall,
  CasualRMApprovals: usersReducer.CasualRMApprovals,
  CasualFormUpdates: usersReducer.CasualFormUpdates,
  managerapproverequestdata: usersReducer.managerapproverequestdata,
  ReportSheetDeleted: usersReducer.ReportSheetDeleted,
  OvertimeSliceCall: usersReducer.OvertimeSliceCall,
  OvertimeApprove: usersReducer.OvertimeApprove,
  OnboarderRejoindata: usersReducer.OnboarderRejoindata,
  getposttheRejoiningResponse: usersReducer.getposttheRejoiningResponse,
  MyTicketsSliceDatas: usersReducer.MyTicketsSliceDatas,
  bothuserASEmployeee: usersReducer.bothuserASEmployeee,
  Overtime_RegularizationCallEmp: usersReducer.Overtime_RegularizationCallEmp,
  PayLipEMployeeeData: usersReducer.PayLipEMployeeeData,
  FaceVerificationDatas: usersReducer.FaceVerificationDatas,
  ResignationDatasEMp: usersReducer.ResignationDatasEMp,
  ResignationEmpRetrieveEmp: usersReducer.ResignationEmpRetrieveEmp,
  NodueFormEmployeeEditCalllData: usersReducer.NodueFormEmployeeEditCalllData,
  NodueFormEmployeeSLiceRetrieveData:
    usersReducer.NodueFormEmployeeSLiceRetrieveData,
  ReimbursementDataFetchEmp: usersReducer.ReimbursementDataFetchEmp,
  grievenceTypeDatasEmp: usersReducer.grievenceTypeDatasEmp,
  grievenceDatasEmp: usersReducer.grievenceDatasEmp,
  GrievanceApplyForEmpData: usersReducer.GrievanceApplyForEmpData,
  HelpDeskDatasEMP: usersReducer.HelpDeskDatasEMP,
  TrackingParentEmp: usersReducer.TrackingParentEmp,
  TrackingsubCategorytEmp: usersReducer.TrackingsubCategorytEmp,
  helpDeskPostForEmployeee: usersReducer.helpDeskPostForEmployeee,
  EmpAttendaEmpDataGetList: usersReducer.EmpAttendaEmpDataGetList,
  EmpBlockEmpDatagetStored: usersReducer.EmpBlockEmpDatagetStored,
  EmpBlockEmpDataPosttStored: usersReducer.EmpBlockEmpDataPosttStored,
  EmpBlockEmpSiteTransferStored: usersReducer.EmpBlockEmpSiteTransferStored,
  EmpBlockEmpSiteTransferCreate: usersReducer.EmpBlockEmpSiteTransferCreate,
  AttendanceRegularizationSignlemulti:
    usersReducer.AttendanceRegularizationSignlemulti,
  AttendanceRegularizationteamPostSignlemulti:
    usersReducer.AttendanceRegularizationteamPostSignlemulti,
  UnbloadedEmployeeeDataEmp: usersReducer.UnbloadedEmployeeeDataEmp,
  EmployeeClientBranchForEmpData: usersReducer.EmployeeClientBranchForEmpData,
  EmployeeProfilepostUpdateListData:
    usersReducer.EmployeeProfilepostUpdateListData,
  EmployeeProfileGetListData: usersReducer.EmployeeProfileGetListData,
  NodueFormFetchDatasgetFetch: usersReducer.NodueFormFetchDatasgetFetch,
  sitetransferemployeeapidata: usersReducer.sitetransferemployeeapidata,
  SkillAssessmentEmpList: usersReducer.SkillAssessmentEmpList,
  StateFetchDetails: usersReducer.StateFetchDetails,
  RegionFetchDetails: usersReducer.RegionFetchDetails,
  ZoneFetchDetails: usersReducer.ZoneFetchDetails,
  DesignationFetchDetails: usersReducer.DesignationFetchDetails,
  BranchFetchDetails: usersReducer.BranchFetchDetails,
  skillassessmentretieveempdatas: usersReducer.skillassessmentretieveempdatas,
  skillquestionpaperassessment: usersReducer.skillquestionpaperassessment,
  innerquestionskillassessment: usersReducer.innerquestionskillassessment,
  questiontypeskillassessment: usersReducer.questiontypeskillassessment,
  skillassessmentforapplyemppostmethod:
    usersReducer.skillassessmentforapplyemppostmethod,
  skillassessmentforapplyemp_put_method:
    usersReducer.skillassessmentforapplyemp_put_method,

  TicketQuetionsDatas: usersReducer.TicketQuetionsDatas,
  TicketQuestionsCreate: usersReducer.TicketQuestionsCreate,
  TicketQuestionsretrieve: usersReducer.TicketQuestionsretrieve,
  TicketQuestionsEdition: usersReducer.TicketQuestionsEdition,

  TicketSubQuetionsDatas: usersReducer.TicketSubQuetionsDatas,
  TicketSubQuestionsCreate: usersReducer.TicketSubQuestionsCreate,
  TicketingSubQuestionsEditions: usersReducer.TicketingSubQuestionsEditions,
  TicketSubQuestionsRetrieve: usersReducer.TicketSubQuestionsRetrieve,
  TickerSUBQuestionsDelete: usersReducer.TickerSUBQuestionsDelete,
  TrackingrecordgetOfSystemList: usersReducer.TrackingrecordgetOfSystemList,
  Ticketingrecord_dashboard: usersReducer.Ticketingrecord_dashboard,
  RetrieveTickingSystemdatas: usersReducer.RetrieveTickingSystemdatas,
  TickeetRemarkSliceDatas: usersReducer.TickeetRemarkSliceDatas,
  commentsDatas: usersReducer.commentsDatas,
  retrievetheRemarks: usersReducer.retrievetheRemarks,
  ticketstatuschanges: usersReducer.ticketstatuschanges,
  ticketTimeLIneSlicedata: usersReducer.ticketTimeLIneSlicedata,
  TicketingSystemIn: usersReducer.TicketingSystemIn,
  ticketFeedbacklistedslice: usersReducer.ticketFeedbacklistedslice,
  ScopeGettheDatalist: usersReducer.ScopeGettheDatalist,
  ContactPersonEdit: usersReducer.ContactPersonEdit,
  SubCategoryListed: usersReducer.SubCategoryListed,
  CategoryListed: usersReducer.CategoryListed,
  SubCategoryeditandcreateScopeListed:
    usersReducer.SubCategoryeditandcreateScopeListed,
  NearDueCallingdatas: usersReducer.NearDueCallingdatas,
  UdsuserRemarkdssliced: usersReducer.UdsuserRemarkdssliced,
  SubCategorySlicedatas: usersReducer.SubCategorySlicedatas,
  UDSQuetionsDatas: usersReducer.UDSQuetionsDatas,
  InternalTicketCrud: usersReducer.InternalTicketCrud,
  internalcategoryQuestionsEdition:
    usersReducer.internalcategoryQuestionsEdition,
  internalcategoryQuestionsretrieve:
    usersReducer.internalcategoryQuestionsretrieve,
  InternalQuestionsDelete: usersReducer.InternalQuestionsDelete,
  branchqrcodes: usersReducer.branchqrcodes,
  InternalSubQuetionsDatas: usersReducer.InternalSubQuetionsDatas,
  InternalSubQuestionsEditions: usersReducer.InternalSubQuestionsEditions,
  InternalSubQuestionsRetrieve: usersReducer.InternalSubQuestionsRetrieve,
  InternalSUBQuestionsDelete: usersReducer.InternalSUBQuestionsDelete,
  InternalSubQuestionsCreate: usersReducer.InternalSubQuestionsCreate,
  Tracking_unregisterrecordgetOfSystemList:
    usersReducer.Tracking_unregisterrecordgetOfSystemList,
  InternalSubDepartmentsDatas: usersReducer.InternalSubDepartmentsDatas,
  InternalDepartmentsCreate: usersReducer.InternalDepartmentsCreate,
  InternalDepartmentsRetrieveName: usersReducer.InternalDepartmentsRetrieveName,
  InternalDepartmentsEdit: usersReducer.InternalDepartmentsEdit,
  InternalDepartmentsDelete: usersReducer.InternalDepartmentsDelete,
  departmentLevelUserslist: usersReducer.departmentLevelUserslist,
  DepartmentLevelUsersListe: usersReducer.DepartmentLevelUsersListe,
  InternalDepartments_usersDelete: usersReducer.InternalDepartments_usersDelete,
  InternalDepartments_usersRetrivee:
    usersReducer.InternalDepartments_usersRetrivee,
  InternalDepartments_userCrudEditions:
    usersReducer.InternalDepartments_userCrudEditions,
  TrackingrecordgetOfSystemListInternalDepartment:
    usersReducer.TrackingrecordgetOfSystemListInternalDepartment,
  CreateinternalTicketListed: usersReducer.CreateinternalTicketListed,
  internalTicketView: usersReducer.internalTicketView,
  internalTicketFeedBack: usersReducer.internalTicketFeedBack,
  internalTicketChanges: usersReducer.internalTicketChanges,
  internalTicketRemarks: usersReducer.internalTicketRemarks,
  internalTicketTimeline: usersReducer.internalTicketTimeline,
  internalTicketFeedBackpost: usersReducer.internalTicketFeedBackpost,
  internalcommandsticketgetdata: usersReducer.internalcommandsticketgetdata,
  internalTicketDepartmentUsersNames:
    usersReducer.internalTicketDepartmentUsersNames,
  internalcommandticketgetdata: usersReducer.internalcommandticketgetdata,
  internalcommandticketpost: usersReducer.internalcommandticketpost,
  internalTicketCRUDRemarks: usersReducer.internalTicketCRUDRemarks,
  internalRemarks_postvaluesName: usersReducer.internalRemarks_postvaluesName,
  TicketingInertnalDashboardCalls: usersReducer.TicketingInertnalDashboardCalls,
  NeadueInternalTicketCalls: usersReducer.NeadueInternalTicketCalls,
  TicketReassignAssignRejectCalls: usersReducer.TicketReassignAssignRejectCalls,
  TicketDetailsListedNames: usersReducer.TicketDetailsListedNames,
  TicketUnregisterNameAssing: usersReducer.TicketUnregisterNameAssing,
  ticketexcalationrecordoflist: usersReducer.ticketexcalationrecordoflist,
  TicketJournydatasClient: usersReducer.TicketJournydatasClient,
  TicketJournydatasofinternlandcient:
    usersReducer.TicketJournydatasofinternlandcient,
  SubticketForthemanagements: usersReducer.SubticketForthemanagements,
  ClientTicketListedDatahold: usersReducer.ClientTicketListedDatahold,
  gettheClientTicketPostforLonesDatastore:
    usersReducer.gettheClientTicketPostforLonesDatastore,
  gettheClientCategoryDatas: usersReducer.gettheClientCategoryDatas,
  gettheclientsubcategoryApidatas: usersReducer.gettheclientsubcategoryApidatas,
  NotificationDeleteapidatahold: usersReducer.NotificationDeleteapidatahold,
  NotificationListoutapidatahold: usersReducer.NotificationListoutapidatahold,
  NewDashboardNameHolds: usersReducer.NewDashboardNameHolds,
  SubAssignTicketDasboardDataHolds:
    usersReducer.SubAssignTicketDasboardDataHolds,

  AdvanceAttendance_countsRecordsCall:
    usersReducer.AdvanceAttendance_countsRecordsCall,
  StatesOfAdvanceAttendanceRecordsCall:
    usersReducer.StatesOfAdvanceAttendanceRecordsCall,
  EmployeeOfAdvanceAttendanceRecordsCall:
    usersReducer.EmployeeOfAdvanceAttendanceRecordsCall,
  advanceSecondStateSliceCall: usersReducer.advanceSecondStateSliceCall,
  regionalMangerRecords: usersReducer.regionalMangerRecords,
  Customer_table_dashbaord: usersReducer.Customer_table_dashbaord,
  internaltable_dashbaord: usersReducer.internaltable_dashbaord,
  Customer_table_dashbaord_statebased:
    usersReducer.Customer_table_dashbaord_statebased,
  internal_statebased_ticketstatus_table:
    usersReducer.internal_statebased_ticketstatus_table,
  internalEscalationsdashboard: usersReducer.internalEscalationsdashboard,
  ExternalEscalationsdashboard: usersReducer.ExternalEscalationsdashboard,
  TicketTrendDashboard: usersReducer.TicketTrendDashboard,
  PerformanceMetrics: usersReducer.PerformanceMetrics,
  IssueCategroyCustomChart: usersReducer.IssueCategroyCustomChart,
  CustomerSupport_stateCard: usersReducer.CustomerSupport_stateCard,

  CustomerSupportStateList: usersReducer.CustomerSupportStateList,
  CustomerSupportStateChart: usersReducer.CustomerSupportStateChart,
  CustomerSupportRegionalChart: usersReducer.CustomerSupportRegionalChart,

  CustomerSupportRegionalList: usersReducer.CustomerSupportRegionalList,

  CustomerSupportZoneChart: usersReducer.CustomerSupportZoneChart,

  CustomerSupportZoneList: usersReducer.CustomerSupportZoneList,
  CustomerSupportClientChart: usersReducer.CustomerSupportClientChart,

  CustomerSupportClientList: usersReducer.CustomerSupportClientList,
  IssueCategoryListedCustom: usersReducer.IssueCategoryListedCustom,
  CustomPerformanceMatrix: usersReducer.CustomPerformanceMatrix,

  InternalPerformanceMetrics: usersReducer.InternalPerformanceMetrics,
  InternalIssueCategoryTopFive: usersReducer.InternalIssueCategoryTopFive,
  InternalIssueCategoryList: usersReducer.InternalIssueCategoryList,
  InternalSupportChartState: usersReducer.InternalSupportChartState,
  InternalSupportRegionalChart: usersReducer.InternalSupportRegionalChart,
  InternalSupportRegionalList: usersReducer.InternalSupportRegionalList,
  InternalSupportZoneChart: usersReducer.InternalSupportZoneChart,
  InternalSupportZoneList: usersReducer.InternalSupportZoneList,
  InternalSupportClientChart: usersReducer.InternalSupportClientChart,
  InternalSupportClientList: usersReducer.InternalSupportClientList,
  InternalCustomPerformanceMatrix: usersReducer.InternalCustomPerformanceMatrix,
  InternalSupportStateList: usersReducer.InternalSupportStateList,
  InternalSupportTrendsTickets: usersReducer.InternalSupportTrendsTickets,

  customer_geolocation_state: usersReducer.customer_geolocation_state,
  customer_geolocation_regional: usersReducer.customer_geolocation_regional,
  customer_geolocation_zone: usersReducer.customer_geolocation_zone,
  customer_geolocation_client: usersReducer.customer_geolocation_client,

  internalsupport_regionlist: usersReducer.internalsupport_regionlist,
  internalsupport_zone: usersReducer.internalsupport_zone,
  internalsupport_client: usersReducer.internalsupport_client,

  EmployeeEditActions_exitings: usersReducer.EmployeeEditActions_exitings,
  masterdashboard_records: usersReducer.masterdashboard_records,
  masterdashboard_cruds_tocall: usersReducer.masterdashboard_cruds_tocall,
  organization_filterlist_tocall: usersReducer.organization_filterlist_tocall,
  OnboardingLimitions_stored: usersReducer.OnboardingLimitions_stored,
  Unblocking_emp_changes: usersReducer.Unblocking_emp_changes,
  ExitFlow_List: usersReducer.ExitFlow_List,
  ExitFlow_Update: usersReducer.ExitFlow_Update,
  exit_flow_managemanets: usersReducer.exit_flow_managemanets,
  ShifteexcelshetUpdates: usersReducer.ShifteexcelshetUpdates,
  PreviousPagePosition: usersReducer.PreviousPagePosition,
  Reliever_fetching_response: usersReducer.Reliever_fetching_response,
  User_clinetDetailsListOut: usersReducer.User_clinetDetailsListOut,
  SiteTransferDetailsExportSheet: usersReducer.SiteTransferDetailsExportSheet,
  ExitNewFlowDetailsExportSheet: usersReducer.ExitNewFlowDetailsExportSheet,
});
export default rootReducer;
